import { cn } from "../../lib/cn";
import { formatPercent, formatWeight, shortAssetId } from "../../lib/format";
import type { WeightRow } from "./rows";

export function WeightsTable({
	rows,
	apyByAsset,
}: {
	rows: WeightRow[];
	apyByAsset: Record<string, string>;
}) {
	return (
		<div className="space-y-2">
			<h3 className="text-xs font-semibold uppercase tracking-wide text-slate-400">
				Before → after
			</h3>
			<div className="overflow-hidden rounded-lg border border-slate-800">
				<table className="w-full text-sm">
					<thead className="bg-slate-900/60 text-left text-xs uppercase tracking-wide text-slate-400">
						<tr>
							<th className="px-3 py-2 font-medium">Asset</th>
							<th className="px-3 py-2 text-right font-medium">Before</th>
							<th className="px-3 py-2 text-right font-medium">After</th>
							<th className="px-3 py-2 text-right font-medium">Δ</th>
							<th className="px-3 py-2 text-right font-medium">APY</th>
						</tr>
					</thead>
					<tbody className="divide-y divide-slate-800">
						{rows.map((row) => (
							<tr key={row.assetId}>
								<td className="px-3 py-2 font-mono text-xs text-slate-200">
									{row.assetId === "cash"
										? "cash"
										: shortAssetId(row.assetId, 24)}
								</td>
								<td className="px-3 py-2 text-right font-mono">
									{formatWeight(row.before)}
								</td>
								<td className="px-3 py-2 text-right font-mono">
									{formatWeight(row.after)}
								</td>
								<td
									className={cn(
										"px-3 py-2 text-right font-mono text-xs",
										row.delta > 0
											? "text-emerald-300"
											: row.delta < 0
												? "text-rose-300"
												: "text-slate-400",
									)}
								>
									{row.delta === 0
										? "—"
										: `${row.delta > 0 ? "+" : ""}${(row.delta * 100).toFixed(2)}%`}
								</td>
								<td className="px-3 py-2 text-right font-mono text-emerald-300">
									{row.assetId === "cash"
										? "—"
										: formatPercent(apyByAsset[row.assetId] ?? "0")}
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</div>
	);
}
